export const notifications = {
  toasts: {
    defaultBulkError: 'Action cannot be completed.',
    defaultBulkPending: 'Action is in progress. You\'ll be notified when it\'s done.',
    defaultBulkSuccess: 'Action complete.',
  }
};
